import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import i18n from 'i18next';
import useStyles from './MissionName.styles';
import TextField from '../../../common/components/fields/TextField';
import { Icon } from '../../../common/components/icons';
import { sizeEnum } from '../../../common/components/icons/Icon';

const MissionName = () => {
  const classes = useStyles();

  const { errors, submitCount } = useFormikContext();

  const isInvalid = useMemo(() => submitCount > 0 && errors && errors.name, [submitCount, errors]);

  const errorIcon = useMemo(() => <Icon icon="warning" size={sizeEnum.small} className={classes.errorIcon} />, [classes.errorIcon]);

  return (
    <div className={classes.root}>
      <div className={classes.title}>{i18n.t('common.entity.mission')}</div>
      <TextField name="name" placeholder="Name" suffix={isInvalid ? errorIcon : undefined} />
    </div>
  );
};

MissionName.propTypes = {};

MissionName.defaultProps = {};

export default MissionName;
